import { createSelector } from '@ngrx/store';
import * as fromReducers from '../reducers';

export const getFlightAirlinesFeatureState = createSelector(
  fromReducers.getTravelInformationState,
  (state: fromReducers.TravelInformationState) => state.flightAirlines
);
